// Shared tournament category constants. Keep in sync with backend (server.py).

export const AGE_CATEGORIES = ['U12', 'U14', 'U16', 'U18', 'U19', 'U21', 'U23', 'Open'];
export const GENDER_CATEGORIES = ['Boys', 'Girls', 'Men', 'Women', 'Mixed'];
